import {Model} from '@vuex-orm/core';

export class TestInstanceAnswer extends Model {
  static entity = 'test-instance_answers';

  static primaryKey = ['testInstanceId', 'answerId'];

  static fields() {
    return {
      testInstanceId: this.attr(null),
      answerId: this.attr(null),
    };
  }

  testInstanceId: number;
  answerId: number;
}
